
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SummaryViewAccountDialog extends SiteEntityDialog<SummaryViewAccountRow, any> {
        protected getFormKey() { return SummaryViewAccountForm.formKey; }
        protected getIdProperty() { return SummaryViewAccountRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewAccountRow.localTextPrefix; }
        protected getNameProperty() { return SummaryViewAccountRow.nameProperty; }
        protected getService() { return SummaryViewAccountService.baseUrl; }

        protected form = new SummaryViewAccountForm(this.idPrefix);

    }
}